<template>
  <ShuffleLessonView></ShuffleLessonView>
</template>

<script>
import ShuffleLessonView from "@/components/lessons/ShuffleLessonView";
export default {
  components: {
    ShuffleLessonView,
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/vars';
</style>
